import { render, staticRenderFns } from "./TemplateViewerModal.vue?vue&type=template&id=70134eac"
import script from "./TemplateViewerModal.vue?vue&type=script&lang=js"
export * from "./TemplateViewerModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateViewerModal.vue?vue&type=style&index=0&id=70134eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports